import { useRef } from "react";
import { imgUrl } from "@/lib/api";

export default function DragStrip({ images }) {
  const ref = useRef(null);
  const drag = useRef({ down: false, x: 0, left: 0 });
  const onDown = (e) => { drag.current = { down: true, x: e.pageX, left: ref.current.scrollLeft }; };
  const onMove = (e) => {
    if (!drag.current.down) return;
    ref.current.scrollLeft = drag.current.left - (e.pageX - drag.current.x);
  };
  const end = () => { drag.current.down = false; };
  return (
    <div ref={ref} onMouseDown={onDown} onMouseMove={onMove} onMouseUp={end} onMouseLeave={end}
      data-testid="about-strip"
      className="no-scrollbar flex gap-4 overflow-x-auto cursor-grab active:cursor-grabbing select-none">
      {images.map((src, i) => (
        <div key={i} className="shrink-0 w-[62vw] sm:w-[320px] aspect-square overflow-hidden bg-surface">
          <img src={imgUrl(src, 700)} alt="Qissa studio work detail" loading="lazy" className="w-full h-full object-cover pointer-events-none" />
        </div>
      ))}
    </div>
  );
}
